import { SuccessfulApiResponse } from "@eryxcoop/appyx-comm";

export default class SalesByDestinationResponse extends SuccessfulApiResponse {
    // MOCK TEMPORAL: el backend todavía no expone `dashboard/sales-by-destination`. Esta es la
    // forma que tendrá la respuesta real (incluye cajas). Se sirve desde el client vía
    // `asDefaultResponse()` hasta que el endpoint exista.
    static defaultResponse() {
        return {
            object: {
                sales_by_destination: [
                    { iso: "032", name: "Argentina", net_sales: "867530000", net_boxes: "206555", percentage: "69.6", type: "domestic" },
                    { iso: "076", name: "Brasil", net_sales: "180000000", net_boxes: "42857", percentage: "14.5", type: "export" },
                    { iso: "152", name: "Chile", net_sales: "100000000", net_boxes: "23810", percentage: "8.0", type: "export" },
                    { iso: "858", name: "Uruguay", net_sales: "55000000", net_boxes: "13095", percentage: "4.4", type: "export" },
                    { iso: "600", name: "Paraguay", net_sales: "25000000", net_boxes: "5952", percentage: "2.0", type: "export" },
                    { iso: "068", name: "Bolivia", net_sales: "18330000", net_boxes: "4364", percentage: "1.5", type: "export" },
                ],
            },
            errors: [],
        };
    }

    salesByDestination() {
        return this.content().sales_by_destination.map((row) => this._adaptRow(row));
    }

    _adaptRow(row) {
        return {
            iso: row.iso,
            name: row.name,
            sales: this._toNumber(row.net_sales),
            boxes: this._toNumber(row.net_boxes),
            percentage: this._toNumber(row.percentage),
            type: row.type,
        };
    }

    _toNumber(value) {
        return value == null ? null : Number(value);
    }
}
